<button class="btn btn-primary m-3" style="position: fixed; top: 0; left: 0; z-index: 100;" (click)="toggleSidebar($event)">
  <i class="fa fa-bars"></i>
</button>


<nav class="sidebar sidebar-dark">
  <div class="sidebar-header bg-primary">
    <!--- Logo -->
    <a routerLink="/" class="sidebar-brand">
      <img
        style="width: 150px; vertical-align:baseline;"
        class="image-logo"
        src="assets/images/taxilink_logo_hor_final.png"
        alt=""
      />
    </a>
    <!--- Toggler -->
    <div
      class="sidebar-toggler not-active"
      #sidebarToggler
      (click)="toggleSidebar($event)"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  
  <div
    class="sidebar-body"
    (mouseenter)="operSidebarFolded()"
    (mouseleave)="closeSidebarFolded()"
    [perfectScrollbar]
    
  >
    <!-- <div class="form-group col-12">
            <label class="control-label"> Company <span class="text-danger">*</span></label>
            <select [(ngModel)]="selectedCompany" class="form-control form-control-sm mb-3" (change)="updateCompany($event)">
              <option *ngFor="let c of companies" [ngValue]="c">{{c.name}}</option>
            </select>
        </div> -->

      <app-select-company></app-select-company>

    <!--- Sidemenu start -->

    <ul class="sidebar-nav metismenu" id="sidebar-menu" #sidebarMenu>
      <ng-container *ngFor="let item of menuItems">
        <li *ngIf="item.isTitle" class="nav-item nav-category">
          {{ item.label[language] }}
        </li>

        <li *ngIf="!item.isTitle" class="nav-item">
          <a class="nav-link" *ngIf="hasItems(item)" href="javascript:void(0);">
            <span
              *ngIf="item.fontawesomeIcon == undefined || !item.fontawesomeIcon"
            >
              <i
                class="link-icon"
                [attr.data-feather]="item.icon"
                appFeatherIcon
                *ngIf="item.icon"
              ></i>
            </span>
            <span *ngIf="item.fontawesomeIcon" style="width: 10px">
              <i [class]="item.icon" *ngIf="item.icon"></i>
            </span>
            <span class="link-title"> {{ item.label[language] }}</span>
            <span
              class="link-arrow"
              data-feather="chevron-down"
              appFeatherIcon
            ></span>
          </a>

          <a
            class="nav-link nav-link-ref"
            [routerLink]="item.link"
            *ngIf="!hasItems(item)"
            [attr.data-parent]="item.parentId"
          >
            <span
              *ngIf="item.fontawesomeIcon == undefined || !item.fontawesomeIcon"
            >
              <i
                class="link-icon"
                [attr.data-feather]="item.icon"
                appFeatherIcon
                *ngIf="item.icon"
              ></i>
            </span>
            <span *ngIf="item.fontawesomeIcon" style="width: 10px">
              <i [class]="item.icon" *ngIf="item.icon"></i>
            </span>
            <span class="link-title"> {{ item.label[language] }}</span>
            <span
              class="badge badge-{{ item.badge.variant }}"
              *ngIf="item.badge"
              >{{ item.badge.text }}</span
            >
          </a>

          <ul
            class="sidebar-nav sub-menu nav-second-level"
            *ngIf="hasItems(item)"
            aria-expanded="false"
          >
            <li
              class="nav-item"
              *ngFor="let subitem of item.subItems"
              [ngClass]="{ 'side-nav-item': hasItems(subitem) }"
            >
              <a
                class="nav-link side-nav-link-a-ref"
                *ngIf="hasItems(subitem)"
                href="javascript:void(0);"
              >
                <span
                  *ngIf="
                    item.fontawesomeIcon == undefined || !item.fontawesomeIcon
                  "
                >
                  <i
                    class="link-icon"
                    [attr.data-feather]="subitem.icon"
                    appFeatherIcon
                    *ngIf="subitem.icon"
                  ></i>
                </span>
                <span *ngIf="item.fontawesomeIcon" style="width: 10px">
                  <i [class]="item.icon" *ngIf="subitem.icon"></i>
                </span>
                <span class="link-title"> {{ subitem.label[language] }}</span>
                <span
                  class="link-arrow"
                  data-feather="chevron-down"
                  appFeatherIcon
                ></span>
              </a>

              <a
                class="nav-link nav-link-ref"
                [routerLink]="subitem.link"
                *ngIf="!hasItems(subitem)"
                [attr.data-parent]="subitem.parentId"
              >
                <span
                  *ngIf="
                    item.fontawesomeIcon == undefined || !item.fontawesomeIcon
                  "
                >
                  <i
                    class="link-icon"
                    [attr.data-feather]="subitem.icon"
                    appFeatherIcon
                    *ngIf="subitem.icon"
                  ></i>
                </span>
                <span>
                  {{ subitem.label[language] }}
                </span>
                <span *ngIf="item.fontawesomeIcon">
                  <i [class]="item.icon" *ngIf="subitem.icon"></i>
                </span>
              </a>

              <ul
                class="sidebar-nav sub-menu nav-third-level"
                *ngIf="hasItems(subitem)"
                aria-expanded="false"
              >
                <li
                  class="nav-item"
                  *ngFor="let subSubitem of subitem.subItems"
                >
                  <a
                    class="nav-link nav-link-ref"
                    [routerLink]="subSubitem.link"
                    [routerLinkActive]="['active']"
                    [attr.data-parent]="subSubitem.parentId"
                  >
                    <span
                      *ngIf="
                        item.fontawesomeIcon == undefined ||
                        !item.fontawesomeIcon
                      "
                    >
                      <i
                        class="link-icon"
                        [attr.data-feather]="subitem.icon"
                        appFeatherIcon
                        *ngIf="subitem.icon"
                      ></i>
                    </span>
                    <span>
                      {{ subSubitem.label[language] }}
                    </span>
                    <span *ngIf="item.fontawesomeIcon">
                      <i [class]="item.icon" *ngIf="subitem.icon"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>
      <!-- <li class="nav-item nav-category">Docs</li>
            <li class="nav-item">
                <a href="https://www.nobleui.com/angular/documentation/docs.html" target="_blank" class="nav-link">
                    <i class="link-icon" data-feather="hash" appFeatherIcon></i>
                    <span class="link-title">Documentation</span>
                </a>
            </li> -->
            


            <li class="nav-item">
              <p class="mb-3"></p>
              <div class="info text-left">
                <p class="name text-white font-weight-bold mb-0">{{ user.first_name }} {{ user.last_name }}</p>
                <p class="email text-white mb-0" title="{{ user.email }}">{{ user.email }}</p>
              </div>
            </li>
            <li class="nav-item">
              <a href="" (click)="onLogout($event)" class="nav-link">
                  <i class="feather icon-log-out"></i>
                  <span>Sair</span>
              </a>
            </li>

    </ul>

    <!--- Sidemenu end -->
  </div>
</nav>
<nav class="settings-sidebar">
  <!-- <div class="sidebar-body">
        <a href="" class="settings-sidebar-toggler" (click)="toggleSettingsSidebar($event)">
            <i class="icon feather icon-settings"></i>
        </a>
        <h6 class="text-muted">Sidebar:</h6>
        <div class="form-group border-bottom">
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="sidebarThemeSettings"
                        (change)="onSidebarThemeChange($event)" id="sidebarLight" value="sidebar-light" checked>
                    <i class="input-frame"></i>
                    Light
                </label>
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="sidebarThemeSettings"
                        (change)="onSidebarThemeChange($event)" id="sidebarDark" value="sidebar-dark">
                    <i class="input-frame"></i>
                    Dark
                </label>
            </div>
        </div>
        <div class="theme-wrapper">
            <h6 class="text-muted mb-2">Light Theme:</h6>
            <a class="theme-item active" href="https://www.nobleui.com/angular/template/demo1/">
                <img src="assets/images/screenshots/light.jpg" alt="light theme">
            </a>
            <h6 class="text-muted mb-2">Dark Theme:</h6>
            <a class="theme-item" href="https://www.nobleui.com/angular/template/demo2/">
                <img src="assets/images/screenshots/dark.jpg" alt="dark theme">
            </a>
        </div>
    </div> -->
  
</nav>
